import React, { useState } from 'react';
import PageContainer from 'containers/PageContainer';
import { Redirect } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import FindAccountView from 'views/FindAccountView';
import { findAccount } from 'gateways/Api';
import { setAppBusy } from 'store/actions/system';
import { setAccountId, setEmailAddress, setUser } from 'store/actions/user';
import useMessages from 'hooks/useMessages';
import { Auth } from 'lib/Amplify';
import FindAccountErrorView from 'views/FindAccountErrorView';

const ACCOUNT_NOT_FOUND_ERROR_MESSAGE = 'Sorry. We\'re having trouble matching your account. If you\'re sure your '
  + 'information is correct please contact Customer Services on the details below.';

const FindAccountContainer = () => {
  const dispatch = useDispatch();
  const accountId = useSelector((state) => state.accountId);
  const [error, setError] = useState('');
  const { genericFailureMessage } = useMessages();
  const [failedAttempts, setFailedAttempts] = useState(0);

  const handleSubmit = (dob) => {
    dispatch(setAppBusy(true));
    findAccount(dob)
      .then((res) => {
        if (res) {
          Auth.currentAuthenticatedUser({ bypassCache: true })
            .then(() => dispatch(setAccountId(res.data.message.accountId)));
        } else {
          const newFailedAttemps = failedAttempts + 1;
          setFailedAttempts(newFailedAttemps);
          if (newFailedAttemps > 2) {
            Auth.signOut();
            dispatch(setUser(null));
            dispatch(setEmailAddress(null));
            return;
          }
          setError(ACCOUNT_NOT_FOUND_ERROR_MESSAGE);
        }
      })
      .catch(() => {
        genericFailureMessage();
      })
      .finally(() => dispatch(setAppBusy(false)));
  };

  if (accountId) {
    return <Redirect to="/overview" />;
  }

  if (failedAttempts > 2) {
    return (
      <PageContainer>
        <FindAccountErrorView />
      </PageContainer>
    );
  }

  return (
    <PageContainer requiresLogin>
      <FindAccountView
        onSubmit={handleSubmit}
        error={error}
      />
    </PageContainer>
  );
};

FindAccountContainer.displayName = 'FindAccountContainer';

export default FindAccountContainer;
